export default {
  trackEvent(eventName, eventData = {}) {
    if (window.gtag) {
      window.gtag('event', eventName, eventData);
    }
  }
};
